var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExport2Excel = function SvgExport2Excel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#export2excel_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#185C37",
    d: "M10.046 6.65 3.721 5.6v7.758c0 .355.305.642.682.642h10.915c.376 0 .682-.287.682-.642V10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21A366",
    d: "M10.046 0H4.403c-.377 0-.682.287-.682.642V3.5L10.046 7l3.35 1.05L16 7V3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#107C41",
    d: "M3.72 3.5h6.326V7H3.721z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M8.248 2.8H3.721v8.75h4.527c.376-.001.68-.288.682-.642V3.442c-.001-.354-.306-.64-.682-.642",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M7.876 3.15H3.72v8.75h4.155c.376-.001.68-.288.682-.642V3.792c-.001-.354-.306-.64-.682-.642",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M7.876 3.15H3.72v8.05h4.155c.376-.001.68-.288.682-.641V3.792c-.001-.354-.306-.64-.682-.642",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M7.504 3.15H3.72v8.05h3.783c.376-.001.68-.288.682-.641V3.792c-.001-.354-.306-.64-.682-.642",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#export2excel_svg__b)",
    d: "M.682 3.15h6.822c.377 0 .682.287.682.642v6.417c0 .354-.305.641-.682.641H.682c-.377 0-.682-.287-.682-.641V3.792c0-.355.305-.642.682-.642"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m2.112 9.085 1.435-2.09-1.315-2.08H3.29l.717 1.33q.1.19.137.281h.009q.07-.15.149-.293l.767-1.318h.97L4.691 6.983l1.383 2.102H5.04l-.829-1.46a1 1 0 0 1-.099-.194h-.012a1 1 0 0 1-.096.189l-.853 1.465z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33C481",
    d: "M15.318 0h-5.272v3.5H16V.642C16 .287 15.694 0 15.318 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#107C41",
    d: "M10.046 7H16v3.5h-5.954z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "export2excel_svg__b",
    x1: 1.422,
    x2: 6.289,
    y1: 2.649,
    y2: 11.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18884F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6631"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "export2excel_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v14H0z"
  })))));
};
export default SvgExport2Excel;